import React, { useMemo } from 'react';

import { useResponsiveBreakpoints } from '../../../../hooks/useResponsiveBreakpoints';

import ToolTip from '../../../../design-system/ToolTip/ToolTip';

const TagsContentSection = ({ tag_groups }) => {
    const sortedTagGroups = useMemo(() => {
        return [...(tag_groups || [])].sort((a, b) => a.order - b.order);
    }, [tag_groups]);

    const { isMobile: isSmallMobile } = useResponsiveBreakpoints({ maxMobileWidth: 480 });

    return (
        <ul className="flex flex-col gap-5">
            {sortedTagGroups.map((group) => {
                const { name, label, content } = group;

                return (
                    <li key={name} className="flex flex-col gap-4">
                        <p className="font-body-bold text-body-bold-s text-neutral-500">{label}</p>

                        <ul className="flex flex-col">
                            {content?.map((item) => {
                                const { name, label, tag } = item;

                                return (
                                    <li
                                        key={name}
                                        className="p-1.5 flex items-center justify-between gap-3 border-b-1 border-neutral-100"
                                    >
                                        <p className="font-body text-body-regular-xs text-neutral-500">
                                            {label}
                                        </p>

                                        <ToolTip
                                            text={tag?.description}
                                            position="top-right"
                                            shift="2px"
                                            useInternalHoverStateToShowToolTip
                                            maxWidth={isSmallMobile ? 280 : 360}
                                        >
                                            <div
                                                className="px-2 min-h-[24px] flex items-center font-body-medium text-body-medium-xs cursor-default whitespace-nowrap"
                                                style={{ color: tag?.text_color }}
                                            >
                                                {tag?.label}
                                            </div>
                                        </ToolTip>
                                    </li>
                                );
                            })}
                        </ul>
                    </li>
                );
            })}
        </ul>
    );
};

export default TagsContentSection;
